export const getUUID = () => crypto.randomUUID()
